import React from "react";
import Notice from "Components/Notice";
import ImageCrop from "Components/ImageCrop";
import { langCheck } from "Pub/js/utils.js";
import platform from "Pub/js/platform";
const { base } = platform;
const { NCModal, NCButton, NCTooltip } = base;
import "./index.less";

export default class ImgChooser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            imgObj: null,
            src: null,
            newImgSrc: null,
            pixelCrop: null,
            crop: {
                x: 10,
                y: 10,
                width: 80,
                aspect: 1
            }
        };
        this.imageType = 'image/jpeg';
    }
    /**
     * 模态框取消事件
     */
    onCancel = () => {
        let imgObj = this.refs.webuploaderElement;
        this.setState(
            {
                imgObj: null,
                src: null,
                newImgSrc: null,
                pixelCrop: null,
                visible: false
            },
            () => {
                imgObj.value = "";
            }
        );
    };
    /**
     * 模态框确定事件
     */
    onOk = () => {
        let { imgObj, pixelCrop } = this.state;
        let { onChange } = this.props;
        // 获取剪切后的图片文件Blob对象
        let imgFileObj = getCroppedImg(imgObj, pixelCrop, '', "base64", this.imageType);
        onChange && onChange(imgFileObj);
        this.onCancel();
    };
    /**
     * 文件选择事件
     */
    onSelectFile = e => {
        const { onChange, needCrop = true } = this.props;
        if (e.target.files && e.target.files.length > 0) {
            let imgFileObj = e.target.files;
            const imgSize = 500 * 1024;
            if (imgFileObj[0].size > imgSize) {
                Notice({
                    status: "warning",
                    msg: langCheck("0000PUB-000502") /* 国际化处理： 上传的图片大于500K,请重新选择!*/
                });
                return;
            }

            this.imageType = imgFileObj[0].type;
            const reader = new FileReader();
            reader.addEventListener(
                "load",
                () => {
                    if (needCrop) {
                        this.setState({
                            src: reader.result,
                            visible: true
                        });
                    } else {
                        onChange && onChange(reader.result);
                    }
                    this.refs.webuploaderElement.value = '';
                },
                false
            );
            reader.readAsDataURL(imgFileObj[0]);
        }
    };
    /**
     * 图片加载完毕
     * @param {Object}  imgObj - 图片DOM对象。
     * @param {Object} pixelCrop - 像素转换裁剪后的对象
     */
    onImageLoaded = (imgObj, pixelCrop) => {
        if (imgObj) {
            // 获取裁剪图片base64
            let newImgSrc = getCroppedImg(imgObj, pixelCrop, '', "base64", this.imageType);
            this.setState({
                newImgSrc,
                pixelCrop,
                imgObj
            });
        }
    };
    /**
     * 调整大小，调整大小，拖动或轻推后发生的回调
     * @param {Object}  crop - 当前裁剪状态对象。
     * @param {Object} pixelCrop - 像素转换裁剪后的对象
     */
    onCropComplete = (crop, pixelCrop) => {
        let { imgObj } = this.state;
        if (imgObj) {
            // 获取裁剪图片base64
            let newImgSrc = getCroppedImg(imgObj, pixelCrop, '', "base64", this.imageType);
            this.setState({
                newImgSrc,
                pixelCrop
            });
        }
    };
    /**
     * 裁剪变化状态
     * @param {Object}  crop - 当前裁剪状态对象。
     */
    onCropChange = crop => {
        this.setState({ crop });
    };
    render() {
        let { src, crop, visible, newImgSrc } = this.state;
        const { className, children } = this.props;
        return (
            <div className={`img-chooser ${className || ''}`}>
                <input
                    type="file"
                    name="file"
                    class="img-chooser-input"
                    onChange={this.onSelectFile}
                    ref={"webuploaderElement"}
                    accept="image/jpg,image/jpeg,image/png,image/gif"
                    title=""
                />
                {children}

                <NCModal
                    show={visible}
                    size="lg"
                    width={572}
                    onOk={this.onOk}
                    onCancel={this.onCancel}
                    wrapClassName="img-chooser-modal"
                    keyboard={true}
                >
                    <NCModal.Header closeButton>
                        <NCModal.Title>{langCheck('0000PUB-000489' /* 编辑 */)}</NCModal.Title>
                    </NCModal.Header>
                    <NCModal.Body>
                        <ImageCrop
                            imgSrc={src}
                            imgCrop={crop}
                            newImgSrc={newImgSrc}
                            onImageLoaded={this.onImageLoaded}
                            onCropComplete={this.onCropComplete}
                            onCropChange={this.onCropChange}
                        />
                    </NCModal.Body>
                    <NCModal.Footer>
                        <NCTooltip
                            placement="top"     
                            overlay={`${langCheck("0000PUB-000001")}(Alt + Y)`} 
                        >
                            <NCButton colors="primary" onClick={this.onOk}>
                                {langCheck('0000PUB-000001' /* 确定 */)}
                                (<span className="underline">Y</span>)
                            </NCButton>
                        </NCTooltip>
                        <NCTooltip
                            placement="top"     
                            overlay={`${langCheck("0000PUB-000000")}(Alt + N)`} 
                        >
                            <NCButton colors="secondary" onClick={this.onCancel}>
                                {langCheck('0000PUB-000000' /* 取消 */)}
                                (<span className="underline">N</span>)
                            </NCButton>
                        </NCTooltip>
                    </NCModal.Footer>
                </NCModal>
            </div>
        );
    }
}

/**
 * 获取裁剪后的图片
 * @param {File} image - Image File Object
 * @param {Object} pixelCrop - pixelCrop Object provided by react-image-crop
 * @param {String} fileName - Name of the returned file in Promise
 * @param {String} type - 需要返回的数据类型 base64 或者 fileObj
 */
export const getCroppedImg = (image, pixelCrop, fileName = 'img_chooser.jpeg', type, imageType = 'image/jpeg') => {
    const canvas = document.createElement("canvas");
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height
    );
    // As Base64 string
    if (type == "base64") {
        return canvas.toDataURL(imageType);
    } else {
        // As a blob
        return new Promise((resolve, reject) => {
            canvas.toBlob(file => {
                file.name = fileName;
                resolve(file);
            }, imageType);
        });
    }
};